var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-links"},[(_vm.showFavorite)?_c('a',{staticClass:"social-share-icon icon-heart",attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.addFavorite()}}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }